/**
 * @desc: 此文件定义通用的公用方法
 */
// 动态加载js
function loadJs(jsUrl) {
  console.log('加载的js路径：', jsUrl)
  if (jsUrl) {
    const sc = document.createElement('script')
    if (sc) {
      sc.type = 'text/javascript'
      sc.src = jsUrl
      document.body.appendChild(sc)
    }
  }
}
// 判断当前是否为C端用户  @return true --C端   false -- B端
function isClient() {
  const url = window.location.href
  return (url.indexOf('terminalId=H5') !== -1 && url.indexOf('channelCode=DP_OWXPA') || // 官微
    localStorage.getItem('setTerminalId') === 'H5' && localStorage.getItem('setChannelCode') === 'DP_OWXPA' ||
    url.indexOf('terminalId=H5') !== -1 && url.indexOf('channelCode=DP_WXMP') || // 微店
    localStorage.getItem('setTerminalId') === 'H5' && localStorage.getItem('setChannelCode') === 'DP_WXMP' ||
    url.indexOf('terminalId=APP') !== -1 && url.indexOf('channelCode=DP_OWXPA') || // 掌上紫金
    localStorage.getItem('setTerminalId') === 'APP' && localStorage.getItem('setChannelCode') === 'DP_OWXPA' || localStorage.getItem('setMotorCode') === 'HE_NANCode' || localStorage.getItem('setMotorCode') === 'SHAAN_XICode' || localStorage.getItem('setMotorCode') === 'HE_BEICode' || localStorage.getItem('setMotorCode') === 'FU_JIANCode' || localStorage.getItem('setMotorCode') === 'NING_BOCode' || localStorage.getItem('setMotorCode') === 'XIA_MENCode' || localStorage.getItem('setMotorCode') === 'HE_BEI_02Code' || localStorage.getItem('setMotorCode') === 'SHAN_XICode' || localStorage.getItem('setMotorCode') === 'HU_NANCode'
  )
}

function generateArray(max) {
  return Array.from({ length: max }, (_, index) => index + 1)
}

// 文件预览和下载功能需要加上token授权信息
export function downloadFile(fileUrl, token, fileName) {
  const viewUrl = fileUrl.startsWith('http://') ? fileUrl.replace(/http:\/\//, 'https://') : fileUrl
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest()
    xhr.open('GET', viewUrl, true)
    xhr.setRequestHeader('Authorization', token)
    xhr.responseType = 'blob' // 获取文件blob数据
    xhr.onload = function() {
      if (xhr.status !== 200) {
        return
      }
      const newUrl = window.URL.createObjectURL(xhr.response) // 生成一个可用的临时url
      // const a = document.createElement('a') // 生成a标签调用点击事件
      // a.setAttribute('href', newUrl)
      // a.setAttribute('target', '_blank')
      // a.setAttribute('download', fileName) // 自定义文件名
      // document.body.appendChild(a)
      // a.click()
      // document.body.removeChild(a)
      resolve(newUrl)
    }
    xhr.send()
    xhr.onerror = (err) => {
      reject(err)
    }
  })
}

export default {
  loadJs,
  isClient,
  generateArray,
  downloadFile
}



// WEBPACK FOOTER //
// ./src/utils/common.js